import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAutoCompleteCheckControlled from '@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled';
import { isNullUndefined } from '@/main/services/utils';
import { getYears, resetReducerYears, useYearReducer } from '@/main/store/vehicle/year';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeYearProps extends GeneralVariableType { }
function VariableTypeYear({
  filter
}: IVariableTypeYearProps) {
  const dispatch = useDispatch();
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const { years: yearsReducer } = useYearReducer(keyReducer);
  const {
    control,
  } = useFormContext();

  useEffect(() => {
    if (isNullUndefined(watcherCountry)) return;    
    dispatch(getYears());
    return () => {
      dispatch(resetReducerYears(keyReducer));
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledYears = isNullUndefined(yearsReducer.data) || yearsReducer.data.length === 1
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputAutoCompleteCheckControlled
        name={`filtersDinamics.${indexField}.value`}
        disableSelectAll
        control={control}
        options={yearsReducer.data || []}
        label={filter.responseServer.filterName}
        disabled={disabledYears}
        isLoading={yearsReducer.isLoading}
        controllerProps={{ rules: { required: filter.responseServer.mandatory } }}
        customInputProps={{ required: filter.responseServer.mandatory, id: idScreen('select-years') }}
        onChangeCustom={(value, optionChanged, reason) => { }}
      />
    </>
  )
}

export default VariableTypeYear